import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-departamentos-incripciones',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './departamentos-incripciones.component.html',
  styleUrl: './departamentos-incripciones.component.scss'
})
export class DepartamentosIncripcionesComponent {
  @Input() data: any;

}
